declare namespace $ {

	type $mol_dimmer__haystack_shm_ba_filter_item_1 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_item['title'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_dimmer__needle_shm_ba_filter_item_2 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_item['highlight'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	type $mol_view__sub_shm_ba_filter_item_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_item_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_filter_item_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__label_shm_ba_filter_item_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check_box['label'] >
	>
	type $mol_check_box__checked_shm_ba_filter_item_7 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_item['checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_ba_filter_item_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_filter_item_9 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_item['only'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__click_shm_ba_filter_item_10 = $mol_type_enforce<
		ReturnType< $shm_ba_filter_item['exclude'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_ba_filter_item_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $shm_ba_filter_item extends $mol_view {
		Title_text( ): $mol_dimmer
		Title( ): $mol_view
		Count( ): $mol_view
		Label( ): $mol_view
		checked( next?: boolean ): boolean
		Check( ): $mol_check_box
		only( next?: any ): any
		Only( ): $mol_button_minor
		exclude( next?: any ): any
		Exclude_icon( ): $mol_icon_close
		Exclude( ): $mol_button_minor
		title( ): string
		count( ): string
		highlight( ): string
		status( ): string
		attr( ): ({ 
			'shm_ba_filter_item_status': ReturnType< $shm_ba_filter_item['status'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map